export enum ActionTypes {
  GetEmailApiSubscription = 'getEmailApiSubscription',
  GetEmailApiSubscriptionSuccess = 'getEmailApiSubscription.success',
  GetEmailApiSubscriptionFailure = 'getEmailApiSubscription.failure',
}
